import { colors } from '../../colors';
var blogList = {
  borderColor: colors.overcast,
  bgColor: colors.white,
  breadcrumbColor: colors.ash,
  subHeadingColor: colors.ash,
  headingColor: colors.ash,
  paraColor: colors.ash,
  filterTextColor: colors.ash
};
export default blogList;